import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { ScheduleUserProvider } from "../contexts/ScheduleUserContext";
import { DialogProvider } from "../contexts/DialogContext";

export const ScheduleUserComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[<ScheduleUserProvider key={0} />, <DialogProvider key={1} />]}
    >
      {children}
    </ContextProviderComposer>
  );
};
